import { render, staticRenderFns } from "./OnClick.vue?vue&type=template&id=03c2e5c0"
import script from "./OnClick.vue?vue&type=script&lang=js"
export * from "./OnClick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports